import React from 'react'
import { withRouter } from 'react-router-dom'
import moment from 'moment'
import { Wrapper } from '../../components_renew/Layout'
import { Button } from 'antd-mobile'
import { postMessage } from '../../utils'
import imgIcon from '../../assets/xiniu/xiniu_02_icon.png'

let flag = ''
switch (process.env['REACT_APP_CHANNEL']) {
  case 'youpin':
    flag = '优品订购'
    break
  case 'xiniu':
    flag = '犀牛订购'
    break
  case 'xibei':
    flag = '犀贝订购'
    break
  case 'xbyg':
    flag = '犀贝易购'
    break
  case 'wanshun':
    flag = '万顺淘金'
    break
  case 'qxtj':
    flag = '全新淘金'
    break
  case 'qxdg':
    flag = '全新订购'
    break
  case 'qxyg':
    flag = '全新易购'
    break
  case 'tjyg':
    flag = '淘金易购'
    break
  case 'ytyg':
    flag = '亚太易购'
    break
  case 'dyyg':
    flag = '东远易购'
    break
  case 'haiou':
    flag = '海鸥订购'
    break
  default:
}
console.log(flag)

@withRouter
class MessageAgreement extends React.PureComponent {
  componentDidMount () {
    document.title = '履约提货'
  }

  render () {
    const { search } = this.props.location
    const params = new URLSearchParams(search)
    const date = params.get('date')
    let dateStr = ''
    if (date && date !== 'undefined') {
      dateStr = date
    } else {
      dateStr = moment().format('YYYY-MM-DD')
    }
    return <Wrapper>
      <div className={'message-agreement'}>
        <div className={'message-agreement__head'}>尊敬的客户：</div>
        <div
          className={'message-agreement__body'}>您已达到系统的履约等级，请完成系统履约制度对指定商品提货，该指定商品已发放至您的卡券，请尽早完成提货以免影响正常订购，如有疑问请联系在线客服。
        </div>
        {/*<div className={'message-agreement__foot'}>{flag}</div>*/}
        <div className={'message-agreement__foot'}>{dateStr}</div>
        <img className={'message-agreement__img'} src={imgIcon} alt=''/>
        <div className={'message-agreement__btn'}>
          <Button color={'primary'} onClick={this.toDelivery}>去提货</Button>
        </div>
      </div>
    </Wrapper>
  }

  toDelivery = () => {
    postMessage({ type: window.POST_TYPE.AGREEMENT })
  }
}

export default MessageAgreement
